import lodash from 'lodash';
import Cookies from 'universal-cookie';
import { v4 as uuid } from 'uuid';

import IEventTrackerProvider, {
  TMeta,
} from 'shared/domain/providers/IEventTrackerProvider';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import IStorageProvider from 'shared/domain/providers/IStorageProvider';

const COOKIE_NAME = 'session_id';
const TEN_YEARS = 60 * 60 * 24 * 365 * 10;

export default class DataLayerEventTrackerProvider
  implements IEventTrackerProvider
{
  private dataLayer: any[];

  constructor(
    private httpProvider: IHTTPProvider,
    private storageProvider: IStorageProvider,
  ) {
    if (!('dataLayer' in window)) {
      lodash.set(window, 'dataLayer', []);
    }

    this.dataLayer = lodash.get(window, 'dataLayer') as any;
  }

  public register(event: string, meta: TMeta, payload: object = {}): void {
    const data = {
      session_id: this.findSessionId(),
      device: meta.device,
      user_id: meta.userId,
      source: 'VIALASER',
      route: meta.route,
      event_type: event,
      env: process.env.REACT_APP_ENV,
      event_data: { ...payload },
    };

    this.dataLayer.push({
      event: data.event_type,
      ...data,
    });

    this.httpProvider.post('development', JSON.stringify(data));
  }

  private findSessionId() {
    const sessionId = this.getSessionId();

    this.saveSessionId(sessionId);

    return sessionId;
  }

  private getSessionId() {
    const storageId = this.storageProvider.get('SESSION_ID');

    if (storageId) return storageId;

    const cookieId = new Cookies().get(COOKIE_NAME);

    if (cookieId) return cookieId;

    return uuid();
  }

  private saveSessionId(sessionId: string) {
    this.storageProvider.store('SESSION_ID', sessionId);
    new Cookies().set(COOKIE_NAME, sessionId, {
      path: '/',
      domain: '.vialaser.com.br',
      maxAge: TEN_YEARS,
    });
  }
}
